import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import moment from 'moment';

import { DatePicker } from '@tcc/crate';

const baseString = 'vra-date';
const Date = ({
  disabled,
  headerText,
  isAppMode,
  maxDate,
  minDate,
  onSelectDate,
  selected,
  validationResult
}) => {
  const isInvalid = get(validationResult, 'isInvalid', false);
  const classString = classNames({
    [`${baseString}`]: true,
    'isInvalid': isInvalid
  });

  const selectedParsed = selected ? moment.utc(selected).format('YYYY-MM-DD') : selected;
  return (
    <section className={classString}>
      <DatePicker
        disabled={disabled}
        label={headerText}
        maxDate={maxDate}
        minDate={minDate}
        moment={moment}
        onChangeDate={onSelectDate}
        readOnly={isAppMode}
        selected={selectedParsed}
        testId='vra-date'
      />
    </section>
  );
};
Date.propTypes = {
  disabled: propTypes.bool,
  headerText: propTypes.string.isRequired,
  isAppMode: propTypes.bool.isRequired,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  onSelectDate: propTypes.func.isRequired,
  selected: propTypes.string,
  validationResult: propTypes.object
};
export default Date;
